import React, { useEffect, useState } from "react";

const Loader = ({ loaderColor = "#d1d5db", size = 32 }) => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(true), 700); // 500ms delay
    return () => clearTimeout(timer);
  }, []);

  if (!showLoader) return null; // Don't render until delay finishes

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: size,
          height: size,
          border: `3px solid ${loaderColor}`,
          borderTop: `3px solid transparent`,
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
        }}
      />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Loader;
